/**
 * Portal Manta · PIPELINES
 * Extraído de App.jsx v29.3 (via AST)
 */
const PIPELINES = {
  analiseLote: {
    id:'analiseLote',
    nome:'Análise completa de lote',
    desc:'Roda Comparador + Conclusão + Narrativa AI em sequência. Usado pela página Agentes IA.',
    agentes:['comparador','conclusao','narrativaAI'],
  },
  novoOrcamento: {
    id:'novoOrcamento',
    nome:'Novo Orçamento (wizard 6 etapas)',
    desc:'Coordena os 5 agentes do wizard de estimativa por similaridade.',
    agentes:['coletorKPI','filtroGeo','similarCalc','geradorOrc','exportador'],
  },
  auditoriaAluci: {
    id:'auditoriaAluci',
    nome:'Auditoria anti-alucinação · Pacote A',
    desc:'Roda os 3 sub-auditores (ABNT/Lei · URL/DOI · SICRO) sobre um texto candidato a laudo/claim/parecer.',
    agentes:['aluciABNT','aluciURL','aluciSICRO'],
  },
  auditoriaPreenchimento: {
    id:'auditoriaPreenchimento',
    nome:'Auditoria de Preenchimento · v28.3',
    desc:'Verifica completude de todos os 4 quadros + 14 KPIs do Novo Estudo · score + benchmarks · auto-disparo ao abrir tab Paramétrico.',
    agentes:['validador'],
  },
};

export { PIPELINES };
export default PIPELINES;
